import ShareIos from './ShareIos'

export default ShareIos
// eslint-disable-next-line import/export
export * from './ShareIos'
